import * as stylex from '@stylexjs/stylex'
import { layout } from '../styles/layout'
import { calloutShadowColors, calloutTypographyColors } from '../styles/themes'
import { color, spacing } from '../styles/tokens.stylex'
import { useRender, UseRenderRenderProp } from '@base-ui/react/use-render'
interface PageSectionProps {
  children?: React.ReactNode
  styles?: stylex.StyleXStyles
  bgVariant?: keyof typeof bgVariants
  renderInner?: UseRenderRenderProp<Record<string, unknown>>
}

export function PageSection({
  children,
  styles,
  bgVariant,
  renderInner,
  ...props
}: PageSectionProps) {
  const inner = useRender({
    defaultTagName: 'div',
    render: renderInner,
    props: {
      ...stylex.props([
        layout.maxWidthWrapper,
        bgVariant === 'callout' && calloutTypographyColors,
        bgVariant === 'dark' && calloutTypographyColors,
        bgVariant === 'callout' && calloutShadowColors,
        sx.root,
        styles,
      ]),
      children,
    },
  })
  return (
    <section
      {...stylex.props([
        layout.sectionWrapper,
        bgVariant && bgVariants[bgVariant],
      ])}
      {...props}
    >
      {inner}
    </section>
  )
}

const sx = stylex.create({
  root: {
    display: 'grid',
    gap: spacing.gap_lrg,
    containerType: 'inline-size',
    containerName: 'section',
  },
})

const bgVariants = stylex.create({
  callout: {
    backgroundColor: color.surfaceBrandOnLightSecondary,
  },
  dark: {
    backgroundColor: color.surfaceDarkBackground,
  },
})
